<!-- =========================================================================================
    File Name: Products.vue
    Description: Tabs - Imports all Products portions
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div id="products-tab">
        
        <h4> {{ $t("ProductsTabTitle") }} </h4> <br>

        <div class="mt-5">
            <vs-tabs alignment="center" :color="tabColor">
                <vs-tab :label="$t('ProductsTab')" icon-pack="feather" icon="icon-package" @click="tabColor = 'green'" >
                    <product-list></product-list>
                </vs-tab>
                <vs-tab :label="$t('ProductGroupTab')" icon-pack="feather" icon="icon-home" @click="tabColor = 'red'" >
                    <product-group-list></product-group-list>
                </vs-tab>
                <vs-tab :label="$t('UnitTab')" icon-pack="feather" icon="icon-box" @click="tabColor = 'blue'" >
                    <product-unit-list></product-unit-list>
                </vs-tab>
                <vs-tab :label="$t('GSTSlabTab')" icon-pack="feather" icon="icon-box" @click="tabColor = 'pink'" >
                    <gst-slab-list></gst-slab-list>
                </vs-tab>
                <vs-tab :label="$t('CESSTab')" icon-pack="feather" icon="icon-box" @click="tabColor = 'pink'" >
                    <cess-rules-list></cess-rules-list>
                </vs-tab>
                <vs-tab label="Local CESS Type" icon-pack="feather" icon="icon-box" @click="tabColor = 'pink'" >
                    <local-cess-type-list></local-cess-type-list>
                </vs-tab>
                <vs-tab label="Local CESS Rules" icon-pack="feather" icon="icon-box" @click="tabColor = 'pink'" >
                    <local-cess-rules-list></local-cess-rules-list>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
</template>

<script>

import ProductList from './product/ProductList.vue'
import ProductGroupList from './product-group/ProductGroupList.vue'
import ProductUnitList from './product-unit/ProductUnitList.vue'
import GstSlabList from './gstSlab/GstSlabList.vue'
import CessRulesList from './cess-rules/CessRulesList.vue'
import LocalCessTypeList from './local-cess-type/LocalCessTypeList.vue'
import LocalCessRulesList from './local-cess-rules/LocalCessRulesList.vue'

export default{
    components: {
        ProductList,
        ProductGroupList,
        ProductUnitList,        
        GstSlabList,
        CessRulesList,
        LocalCessTypeList,
        LocalCessRulesList
    },
    data() {
        return {
            tabColor: 'green'
        }
    },
}
</script>